<template>
  <div>
	<a-modal
		width='50rem'
        id='main-handhomes'
        title='title'
        v-model='visible'
        @on='handleOk'
        @cancel='handleCancel'
        :footer="null" 
        :dialog-style="{top: 13 +'%'}"
        :keyboard='false'
        :maskClosable='false'>
          <div class='main-hand-title'>
            <div style="position: relative;top: .44rem;">全權委託</div>
          </div>
          <div style="display: flex; ">
            <div v-for='(item,ind) in titlearr' 
            :key='ind'
            :class='island == item.component?"wland":"gland"' :style="{flexShrink : ind == 0 ? '0' : ''}" @click="fanfn(item)">
              {{item.name}}</div>

          </div>
          <div id='tubody-mainsk1'>
            <component :is='island' :items='items' :father="this"></component>
            <!--  :aduits='aduit' :ref='island' :applyid='applyid' @child="handchild" :record='record' :forms='form' @childs="isval" -->
          </div>
	</a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import handhome1 from './handhome1.vue'
import handhome2 from './handhome2.vue'
import handhome4 from './handhome4.vue'
export default {
  props: ["items"],
  components:{handhome1,handhome2,handhome4},
  data() {
    return {
      ishand: false,
      visible: true,
      island:'handhome1',
      titlearr:[
        {
          name:'帳戶號碼 - ',
          component:'handhome1',
          island:true
        },
        // {
        //   name:'投資組合',
        //   component:'handhome2',
        //   island:false
        // },
		// {
        //   name:'歷史交易數據',
        //   component:'handhome4',
        //   island:false,
        // },
      ]
    };
  },
  mounted() {
    this.titlearr[0].name = '帳戶號碼 - '+this.items.account_number
  },

  methods: {
    handleCancel(ev) {
        this.$emit("child", 0);
    },
    handleOk(){
      
    },
    fanfn(item){

      let _this = this
        setTimeout(()=>{
        _this.island = item.component;
      },100)	
    },

    

  },
};
</script>

<style lang='scss'>
	#main-handhomes{
		.ant-select-selection{
			color: #000;
			background-color: #fff;
		}
		 .ant-input-disabled {
		    color: #000;
		    background-color: #fff;
		}
		.has-error .ant-form-explain, .has-error .ant-form-split{
			display: none;
		}
		.ant-form-inline .ant-form-item-with-help {
		    margin-bottom: 0;
		}
		.ant-form label{
			font-size: .8rem;
		}
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			min-width:8rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
			cursor: pointer;
		}
		
		.gland{
			display: inline-block;
			width: 8rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
			cursor: pointer;
		}
	}
	
	#tubody-mainsk1>div{
		padding: 1px 0;
	}
	
	#tubody-mainsk1{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			min-height: 12rem;
			max-height: 35rem;
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}

</style>